import { getEnv } from './getEnv';

export const apiUrl = (() => {
  const appEnv = process.env.APP_ENV || process.env.NODE_ENV || 'development';

  switch (appEnv) {
    case 'development':
      return 'https://api.dev.interactivebedtime.com/';
    case 'test':
      return 'https://api.test.interactivebedtime.com/';
    default:
      return 'https://api.interactivebedtime.com/';
  }
})();
